module.exports = __webpack_public_path__ + "img/customer-a-087.94a1ea77.png";